var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "container" },
    [
      _c(
        "b-loading",
        {
          attrs: { "is-full-page": false, "can-cancel": false },
          model: {
            value: _vm.isUpdatingStatus,
            callback: function ($$v) {
              _vm.isUpdatingStatus = $$v
            },
            expression: "isUpdatingStatus",
          },
        },
        [_c("Spinner")],
        1
      ),
      _c(
        "div",
        { staticClass: "broker-actions" },
        [
          _c("h2", { staticClass: "broker-name" }, [
            _vm._v(_vm._s(_vm.broker.name)),
          ]),
          !_vm.userIsBroker
            ? _c(
                "b-switch",
                {
                  attrs: {
                    disabled: _vm.isUpdatingStatus,
                    "native-value": _vm.broker.status,
                    "true-value": "ACTIVE",
                    "false-value": "INACTIVE",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.updateBrokerStatusEmit($event)
                    },
                  },
                  model: {
                    value: _vm.broker.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.broker, "status", $$v)
                    },
                    expression: "broker.status",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.broker.status === "ACTIVE"
                          ? _vm.$t("active")
                          : _vm.$t("inactive")
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "broker-info-container" },
        [
          _vm.broker.idNumber
            ? _c(
                "b-tooltip",
                { attrs: { label: _vm.$t("idNumber"), position: "is-bottom" } },
                [
                  _vm.broker.idNumber
                    ? _c("div", { staticClass: "broker-info" }, [
                        _c("i", {
                          staticClass:
                            "fa-solid fa-address-card has-text-primary",
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.broker.idNumber))]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.broker.email
            ? _c("div", { staticClass: "broker-info" }, [
                _c("a", { attrs: { href: "mailto:" + _vm.broker.email } }, [
                  _c("i", { staticClass: "fa-solid fa-envelope" }),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.broker.email))]),
              ])
            : _vm._e(),
          _vm.broker.phone
            ? _c("div", { staticClass: "broker-info" }, [
                _c(
                  "a",
                  {
                    staticClass: "broker-phone",
                    attrs: {
                      href:
                        "https://api.whatsapp.com/send?phone=" +
                        _vm.broker.phone +
                        "&text=Ol%C3%A1%20" +
                        _vm.broker.name,
                      target: "_blank",
                    },
                  },
                  [_c("i", { staticClass: "fab fa-whatsapp" })]
                ),
                _c("span", [_vm._v(_vm._s(_vm.broker.phone))]),
              ])
            : _vm._e(),
          _vm.broker.assignedCommercialAnalyst
            ? _c(
                "b-tooltip",
                {
                  attrs: {
                    label: _vm.$t("assignedCommercialAnalyst"),
                    position: "is-bottom",
                  },
                },
                [
                  _vm.broker.assignedCommercialAnalyst.name
                    ? _c("div", { staticClass: "broker-info" }, [
                        _c("i", { staticClass: "fa-solid fa-user-tie" }),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.broker.assignedCommercialAnalyst.name)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.broker.prospectsList
            ? _c("div", { staticClass: "broker-info" }, [
                _c("i", { staticClass: "fa-solid fa-users" }),
                _c("span", [
                  _vm._v(_vm._s(`Leads: ${_vm.broker.prospectsList.length}`)),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          _vm.broker.brokerSource
            ? _c(
                "b-tooltip",
                {
                  attrs: {
                    label: _vm.$t("brokerSourceName"),
                    position: "is-bottom",
                  },
                },
                [
                  _vm.broker.brokerSource
                    ? _c("div", { staticClass: "broker-info" }, [
                        _c("i", { staticClass: "fa-solid fa-home" }),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.broker.brokerSource.name ||
                                _vm.$t("simulator")
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }